import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

export type WebVitalsReportHandler = (metric: Metric) => void;

/**
 * Registers Web Vitals observers and forwards each metric to the provided callback.
 * The library can be loaded lazily, so this helper simply wires up the handlers
 * when the callback is defined.
 */
export function reportWebVitals(onReport?: WebVitalsReportHandler) {
  if (!onReport) {
    return;
  }

  const handler = (metric: Metric) => {
    try {
      onReport(metric);
    } catch (error) {
      if (import.meta.env.DEV) {
        console.warn("[web-vitals] metric handler failed", error);
      }
    }
  };

  onCLS(handler);
  onFCP(handler);
  onINP(handler);
  onLCP(handler);
  onTTFB(handler);
}
